import { createSelector } from 'reselect';


const jobs = (store) => store.apps.jobs;

const containerSelector = createSelector([
  jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
],
(filteredState, username, isOpenSauceUser, user, isSubaccountDashboard) => ({
  automated: filteredState.jobs.get('automated'),
  builds: filteredState.jobs.get('builds'),
  automatedLoading: filteredState.jobs.get('automatedLoading'),
  buildsLoading: filteredState.jobs.get('buildsLoading'),
  manualLoading: filteredState.jobs.get('manualLoading'),
  filtersInitialized: filteredState.jobs.get('filtersInitialized'),
  rdcLoading: filteredState.jobs.get('rdcLoading'),
  cloudType: filteredState.jobs.get('cloudType'),
  expandedBuilds: filteredState.buildCards.get('expandedBuilds'),
  failedJobs: filteredState.buildCards.get('failedJobs'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingFeatureEnabled: filteredState.users.get('user').team_management,
  jobsTeamSharingEnabled: filteredState.users.get('user').team_management &&
    filteredState.users.get('user').organization.settings ?
    filteredState.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  manual: filteredState.jobs.get('manual'),
  organizationId: filteredState.users.get('user').organization.id || user.organization.id,
  orgTeams: filteredState.jobs.get('orgTeams'),
  orgUsers: filteredState.jobs.get('orgUsers'),
  filters: filteredState.filters,
  rdc: filteredState.jobs.get('rdc'),
  rdcMoreAvailable: filteredState.jobs.get('rdcMoreAvailable'),
  rdcOffset: filteredState.jobs.get('rdcOffset'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: filteredState.users.get('user'),
  username: username || filteredState.users.get('user').username,
}));

const automatedBuildsTabSelector = createSelector([
  jobs,
],
(filteredState) => ({
  builds: filteredState.jobs.get('builds'),
  buildsLoading: filteredState.jobs.get('buildsLoading'),
  expandedBuilds: filteredState.buildCards.get('expandedBuilds'),
  failedJobs: filteredState.buildCards.get('failedJobs'),
}));

const automatedJobsTabSelector = createSelector([
  jobs,
],
(filteredState) => ({
  automated: filteredState.jobs.get('automated'),
  automatedLoading: filteredState.jobs.get('automatedLoading'),
  rdc: filteredState.jobs.get('rdc'),
  rdcLoading: filteredState.jobs.get('rdcLoading'),
  rdcMoreAvailable: filteredState.jobs.get('rdcMoreAvailable'),
}));

const headlessJobsTabSelector = createSelector([
  jobs,
],
(filteredState) => ({
  automated: filteredState.jobs.get('automated'),
  automatedLoading: filteredState.jobs.get('automatedLoading'),
}));

const manualJobsTabSelector = createSelector([
  jobs,
],
(filteredState) => ({
  manual: filteredState.jobs.get('manual'),
  manualLoading: filteredState.jobs.get('manualLoading'),
}));

export default containerSelector;
export {
  containerSelector,
  automatedBuildsTabSelector,
  automatedJobsTabSelector,
  headlessJobsTabSelector,
  manualJobsTabSelector,
  jobs,
};
